import React, { useState } from 'react';
import { withFormik, Field, Form, getIn } from 'formik';
import { Row, Col, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { FormikDatePicker, InputSelect } from '../../components';
import { debounceIndexSelectionProcessesRequest } from '../../requests/selectionProcesses';
import JobManagementsFilter from '../../components/Utils/Filters/JobManagementsFilter';
import JobTitlesFilter from '../../components/Utils/Filters/JobTitlesFilter';

const CandidateFilter = props => {
  const { errors, touched, setFieldValue, dispatch, handleSubmit } = props;
  const { currentCompany } = useSelector(state => state.auth);
  const [selectedProcess, setSelectedProcess] = useState(null);

  const fetchSelectionProcesses = (inputValue, callback) => {
    debounceIndexSelectionProcessesRequest({
      dispatch,
      params: {
        selector: true,
        name: inputValue,
        sort_column: 'name',
        display_length: 100
      },
      successCallback: response => callback(response.data.data)
    });
  };

  const handleProcessChange = data => {
    setSelectedProcess(data);
    setFieldValue('filterSelectionProcessId', data ? data.value : '');
  };

  const onSubmit = e => {
    e.preventDefault();
    handleSubmit(e);
  };

  return (
    <Form className="employee-search-form py-4 mb-2" onSubmit={onSubmit}>
      <Row>
        <Col xs={12} md={3} className="px-5">
          <Field name="filterSelectionProcessId">
            {({ field }) => (
              <InputSelect
                isClearable
                label="Proceso de Selección"
                placeholder="Seleccionar Proceso de Selección"
                request={fetchSelectionProcesses}
                value={selectedProcess}
                onChange={handleProcessChange}
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3} className="px-5">
          <Field name="filterDateFrom">
            {({ field }) => (
              <FormikDatePicker
                {...field}
                abbr
                isOutsideRange={() => false}
                appendToBody
                repositionPickerOnUpdate
                showClearDate
                label="Fecha:"
                placeholder="dd/mm/aaaa"
                error={getIn(errors, field.name)}
                touched={getIn(touched, field.name)}
              />
            )}
          </Field>
        </Col>
        <Col xs={12} md={3} className="px-5">
          <JobManagementsFilter
            formikValue="filterJobManagement"
            params={{ company_id: currentCompany }}
            labelOverride="Área:"
            placeholderOverride="Seleccione área"
          />
        </Col>
        <Col xs={12} md={3} className="px-5">
          <JobTitlesFilter
            formikValue="filterJobTitle"
            params={{ company_id: currentCompany }}
            labelOverride="Cargo:"
            placeholderOverride="Seleccione cargo"
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col xs={12} md={{ span: 3, offset: 9 }} className="d-flex align-items-end px-5 gap-2">
          <Button className="btn-block" type="submit">
            FILTRAR
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default withFormik({
  mapPropsToValues: () => ({
    filterSelectionProcessId: '',
    filterProcessName: '',
    filterDateFrom: '',
    filterJobManagement: '',
    filterJobTitle: ''
  }),
  handleSubmit: (values, { props }) => {
    if (props && props.formRequest) {
      props.formRequest(values);
    }
  },
  enableReinitialize: true
})(CandidateFilter);
